export default "<div mat-dialog-content>\r\n  {{ info }}\r\n</div>\r\n"